export default __webpack_public_path__ + "static/media/package-7.07cce879.png";